import { useCallback, useSyncExternalStore } from 'react';
import { isTimetableSaveLocked, isTimetableStale, subscribeTimetableSaveGate } from 'src/hooks/timetableSaveGate';

/** 保存の失敗後に詳細を取り直せなかったダイヤか。モジュールの Set を購読するので、取り直しの途中で開き直した詳細にも出る */
export const useIsTimetableStale = (timetableId: number) =>
  useSyncExternalStore(subscribeTimetableSaveGate, useCallback(() => isTimetableStale(timetableId), [timetableId]));

/** 同じダイヤの保存ゲートが取られているか（保存中・失敗後の取り直し中）。開き直した詳細でも分かる */
export const useIsTimetableSaveLocked = (timetableId: number) =>
  useSyncExternalStore(subscribeTimetableSaveGate, useCallback(() => isTimetableSaveLocked(timetableId), [timetableId]));
